/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchnellauswahlDto } from '../../models/schnellauswahl-dto';

export interface GetSchnellauswahlById$Json$Params {

/**
 * Id der Schnellauswahl nach der gesucht werden soll
 */
  schnellauswahlId: string;
}

export function getSchnellauswahlById$Json(http: HttpClient, rootUrl: string, params: GetSchnellauswahlById$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SchnellauswahlDto>> {
  const rb = new RequestBuilder(rootUrl, getSchnellauswahlById$Json.PATH, 'get');
  if (params) {
    rb.path('schnellauswahlId', params.schnellauswahlId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchnellauswahlDto>;
    })
  );
}

getSchnellauswahlById$Json.PATH = '/v1/schnellauswahl/{schnellauswahlId}';
